<template>
	<section>
		<div class="container">
			<div class="row">
				<div class="col-md-8 col-sm-12">
					
					<!-- /.Article -->
					<article class="blog-news detail-wrapper">
						<div class="full-blog">
						
							<!-- Featured Image -->
							<figure class="img-holder">
								<a href="#"><img :src="STATIC_URL + blog.thumb" class="img-responsive" alt="News"></a>
								<div class="blog-post-date theme-bg">
									{{ blog.postDate | dateFormat('from', $i18n.locale) }}
								</div>
							</figure>
							
							<!-- Blog Content -->
							<div class="full blog-content">
								<div class="post-meta">{{ $t('blog.author') }}: <a href="#" class="author theme-cl">{{ blog.author }}</a> | 0 {{ $t('blog.comment') }} </div>
								<a href="blog-detail.html"><h3>{{ blog.subject }}</h3></a>
								<div class="blog-text">
									<div v-html="blog.content" class="blog-content">
									</div>
									<div class="post-meta">{{ $t('blog.category') }}: <span class="category"><a href="javascript:void(0)" class="theme-cl">{{ getBlogCategory(blog.category) }}</a></span></div>
								</div>
								
								<!-- Blog Share Option -->
								<div class="row no-mrg">
									<div class="blog-footer-social">
										<span>{{ $t('blog.share') }} <i class="fa fa-share-alt"></i></span>
										<Share :config="config" />
									</div>
								</div>								
							</div>
							<!-- Blog Content -->
						</div>
					</article>
					<!-- /.Article -->
					<!--<div class="row no-mrg">
						<div class="col-md-12 col-sm-12">
							<BlogComment />
						</div>
					</div>
					<div class="row">
						<div class="col-md-12 col-sm-12">
							<BlogCommentForm />
						</div>
					</div>-->
				</div>				
				<div class="col-md-4 col-sm-12">
					<div class="sidebar">
						<div class="widget-boxed">
							<div class="widget-boxed-header border-0">
								<h4><i class="ti-search padd-r-10"></i>{{ $t('blog.search') }}</h4>
							</div>
							<div class="widget-boxed-body padd-top-5">
								<div class="input-group">
									<input type="text" class="form-control" :placeholder="$t('blog.search-keyword')">
									<span class="input-group-btn">
										<button type="button" class="btn height-50 theme-btn">{{ $t('blog.go') }}</button>
									</span>
								</div>
							</div>
						</div>
		
						<!-- Start: Latest Blogs -->
						<div class="widget-boxed">
							<div class="widget-boxed-header">
								<h4><i class="ti-check-box padd-r-10"></i>{{ $t('blog.latest') }}</h4>
							</div>
							<div class="widget-boxed-body padd-top-5">
								<div class="side-list">
									<ul class="side-blog-list">
										<BlogBox v-for="b in blogs" :key="b.id" :blog="b" />
									</ul>
								</div>
							</div>
						</div>

						<div class="widget-boxed">
							<div class="widget-boxed-header">
								<h4><i class="ti-briefcase padd-r-10"></i>{{ $t('blog.category') }}</h4>
							</div>
							<div class="widget-boxed-body padd-top-10 padd-bot-0">
								<div class="side-list">
									<ul class="category-list">
										<li v-for="c in category"><a href="javascript:void(0)">{{ getBlogCategory(c.category) }} <span :class="getBlogCategoryClass(c.category)">{{ c.num }}</span></a></li>
									</ul>
								</div>
							</div>
						</div>

						<div class="widget-boxed">
							<div class="widget-boxed-header">
								<h4><i class="ti-check-box padd-r-10"></i>{{ $t('blog.relevant') }}</h4>
							</div>
							<div class="widget-boxed-body padd-top-5">
								<div class="side-list">
									<ul class="side-blog-list">
										<BlogBox v-for="b in related" :key="b.id" :blog="b" />
									</ul>
								</div>
							</div>
						</div>						
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<style>
.img-responsive {
}
div.blog-content img {
	max-width: 650px;
}
</style>
<script>
// @ is an alias to /src
import BlogComment from '@/components/blog/BlogComment.vue'
import BlogCommentForm from '@/components/blog/BlogCommentForm.vue'
import BlogBox from '@/components/blog/BlogBox.vue'
import Share from 'vue-social-share'

export default {
  name: 'BlogContent',
  data: function () {
	return {
	  blogs: [],
	  related: [],
	  blog: null,
	  category: []
	}
  },
  components: {
    BlogComment,
    BlogCommentForm,
    BlogBox,
    Share
  },
  computed: {
    config: function() {
      return {
        title: this.blog.subject,
        description: this.blog.content,
        wechatQrcodeTitle: this.$t('blog.wechat'),
        wechatQrcodeHelper: ''
      }
    },
  },
  watch: {
    "$route.params.id": function(val) {
      this.loadData()
    }
  },
  methods: {
    loadData: function() {
        //get blogs
	    let that = this,
	    	blogId = this.$route.params.id
		this.$http.get(this.API3_PREFIX + 'blog/' + blogId).then(function (response) {
		  that.blog = response.data
		}).catch(function (error) {
		  console.log(error)
		});
		this.$http.get(this.API3_PREFIX + 'blogs').then(function (response) {
		  that.blogs = response.data.slice(0, 4)
		}).catch(function (error) {
		  console.log(error)
		});
		this.$http.get(this.API3_PREFIX + 'blog_category').then(function (response) {
		  that.category = response.data
		}).catch(function (error) {
		  console.log(error)
		});
		this.$http.get(this.API3_PREFIX + 'blogs?category=' + that.blog.category).then(function (response) {
		  that.related = response.data.slice(0, 4)
		}).catch(function (error) {
		  console.log(error)
		});
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>